__turbopack_context__.v({
  "account-link-spin": "account-navigation-module__hE5wXW__account-link-spin",
  "accountAvatar": "account-navigation-module__hE5wXW__accountAvatar",
  "accountBadge": "account-navigation-module__hE5wXW__accountBadge",
  "accountCopy": "account-navigation-module__hE5wXW__accountCopy",
  "accountEmail": "account-navigation-module__hE5wXW__accountEmail",
  "accountEntry": "account-navigation-module__hE5wXW__accountEntry",
  "accountIdentityLine": "account-navigation-module__hE5wXW__accountIdentityLine",
  "accountName": "account-navigation-module__hE5wXW__accountName",
  "activeLink": "account-navigation-module__hE5wXW__activeLink",
  "badge": "account-navigation-module__hE5wXW__badge",
  "contentPane": "account-navigation-module__hE5wXW__contentPane",
  "countBadge": "account-navigation-module__hE5wXW__countBadge",
  "groupStart": "account-navigation-module__hE5wXW__groupStart",
  "identity": "account-navigation-module__hE5wXW__identity",
  "itemLabel": "account-navigation-module__hE5wXW__itemLabel",
  "linkPending": "account-navigation-module__hE5wXW__linkPending",
  "linkPendingIdle": "account-navigation-module__hE5wXW__linkPendingIdle",
  "navIcon": "account-navigation-module__hE5wXW__navIcon",
  "navLink": "account-navigation-module__hE5wXW__navLink",
  "navigation": "account-navigation-module__hE5wXW__navigation",
  "portalFooter": "account-navigation-module__hE5wXW__portalFooter",
  "portalShell": "account-navigation-module__hE5wXW__portalShell",
  "sidebar": "account-navigation-module__hE5wXW__sidebar",
  "sidebarLogout": "account-navigation-module__hE5wXW__sidebarLogout",
});
